<template>
  <div class="register">
    <img src="../../assets/imgs/loginBg.jpg" width="100%" :style="{ height: height + 'px' }" > 
    <div class="main-form">
      <div class="main-title">用户登录</div>
      <a-form :form="form">
        <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="账号">
            <a-input v-decorator="['username',{ rules: [{ required: true, message: '请输入账号' }] },]"
            placeholder="请输入账号"/>
        </a-form-item>   
        <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="密码">
            <a-input type="password" v-decorator="['password',{ rules: [{ required: true, message: '请输入密码' }] },]"
            placeholder="请输入密码"/>
        </a-form-item>
        <!-- <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="验证码">
            <a-input v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码' }] }]"
            placeholder="请输入密码"/>
            <img :src="'data:image/png;base64,' + imgCode">
        </a-form-item> -->
        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
            <a-button type="primary" @click="check"  :loading="loading"  style="width:100%;">
                确定
            </a-button>
        </a-form-item>
       </a-form>
    </div>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      height: null,
      formItemLayout,
      formTailLayout,
      loading:false,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      imgCode:''
    };
  },
  mounted() {
    this.height = document.body.clientHeight - 85;
    this.$https.get('/code').then(res=>{
      if(res.code == 200){
        this.imgCode = res.img;
      }  
    })
  },
  methods:{
    ...mapActions('home',['setAcount']),
    check() {
      this.form.validateFields((err,value) => {
        if (!err) {
          value.usertype = '00'
          this.loading = true;
          this.$https.post('/portal/login',value).then(res=>{
              this.loading = false;
              if(res.code == 200){
                 this.$message.success('登录成功');
                 sessionStorage.setItem('token',res.data.access_token);
                 sessionStorage.setItem('acount',value.username)
                 this.setAcount(value.username)
                 this.$store.dispatch('home/updateToken',res.data.access_token);
                 this.$router.push('/');
              }else{
                 this.$message.error(res.msg)
              }
          })
        }
      });
    },
    handleChange(e) {
      this.checkNick = e.target.checked;
      this.$nextTick(() => {
        this.form.validateFields(['nickname'], { force: true });
      });
    },
  }
};
</script>

<style lang="less" scoped>
.register {
  width: 100%;
  .main-form{
      width: 500px;
      position: absolute;
      right:150px;
      top:200px;
      .main-title{
          text-align: center;
          line-height: 80px;
          font-size: 16px;
          font-weight: bold;
          color:#999999;
      }
  }
}
</style>